//
// Copyright 2025 DXOS.org
//

import React from 'react';

export const Placeholder = ({ label }: { label: string }) => {
  return <div className='p-1 text-sm text-subdued'>{label}</div>;
};
